import {
  loginreq,
  req,
  reqJson,
  reqJsonAuto,
  reqHeader,
  reqFile,
  reqLogin,
  axiosPost
} from '@/api/axiosFun';
import {
  system_url,
  security_url
} from '@/api/baseUrl';
import axios from 'axios';
import request from '@/utils/request'

// 用户登录
export const login = (params) => {
  return loginreq("post", security_url + "/user/login", params)
};

// 手机号登录
export const phoneLogin = (params) => {
  return loginreq("post", security_url + "/user/login/phone", params)
};

// 用户注册
export const register = (params) => {
  return loginreq("post", security_url + "/user/register", params)
};

// 发送短信验证码
export const sendSms = (params) => {
  return reqLogin("post", security_url + "/user/sendSms", params)
};

// 验证短信验证码
export const verifySms = (params) => {
  return req('post', security_url + "/user/verifySms", params);
};

// 更换手机号
export const changePhone = (params) => {
  return req("post", security_url + "/user/changePhone", params)
};

// 用户注销
export const logout = (params) => {
  return axiosPost( security_url + "/user/logout", params)
};

// 检查用户订阅状态
export const checkUserSubscription = (params) => {
  return req("post", security_url + `/user/checkPhone`, params)
};

// 获取用户信息
export const getInfo = () => {
  return req("get", system_url + "/getInfo", null)
};

// 获取微信扫码appid 
export const getParamWX = () => {
  var headers = {'Content-Type': 'application/x-www-form-urlencoded', 'secret': '001c0RFa15oGTH0FEDJa1v5iyL2c0RFR'}
  return reqHeader("get", system_url + "/getParam", null, headers)
};

// 获取第三方登录授权URL
export const getThirdPartyAuthUrl = (platform) => {
  return req("get", security_url + `/third/party/account/auth/${platform}`, null)
};

// 完成第三方用户信息
export const completeThirdPartyUserInfo = (platform, thirdPartyId, data) => {
  return req("post", security_url + `/third/party/account/complete/${platform}/${thirdPartyId}`, data)
};

// 获取单位数据
export const getCompanyToName = (companyName) => {
  return req("get", system_url + "/systemCompany/getCompanyToName?companyName=" + companyName, null)
};

// 获取提交加入企业数据
export const getCompanyUser = (userId, companyId) => {
  return req("get", system_url + "/systemCompany/getCompanyUser?userId=" + userId + "&companyId=" + companyId, null)
};

// 保存公司信息
export const saveCompany = (companyId) => {
  return req("get", system_url + "/saveCompany?companyId=" + companyId, null)
};

// 扫码登录
export const wxLogin = (code) => {
  return req('get', system_url + '/wxPCLogin?code=' + code, null)
};

// 编辑用户信息
export const editSystemUser = (params) => {
  return req("post", system_url + "/systemUser/updateOrganizeUser", params)
};

// 获取单位数据
export const getCompanyToId = (companyId) => {
  return req("get", system_url + '/systemCompany/getSystemCompanyBySystemCompanyId/' + companyId, null)
};

// 更新用户状态（启用/禁用）
export const updateUserStatus = (userId, status) => {
  return req("get", system_url + "/systemUser/updateUserStatus?userId=" + userId + "&status=" + status, null)
};

// 获取单个用户信息表数据
export const getSystemUserBySystemUserId = (userId) => {
  return req("get", system_url + "/systemUser/getSystemUserBySystemUserId/" + userId, null)
};

// ===== 角色管理相关API =====
// 获取角色列表
export const getRoleList = (companyId) => {
  return req("get", system_url + "/systemRole/getRoleList?companyId=" + companyId, null)
};

// 获取用户角色列表
export const getUserRoleList = (userId) => {
  return req("get", system_url + "/systemUserRole/list?userId=" + userId, null)
};

// 获取角色已分配的成员列表
export const getRoleUserList = (roleId) => {
  return req("get", system_url + "/systemUserRole/getRoleUserList?roleId=" + roleId, null)
};

// 添加用户角色
export const addUserRole = (params) => {
  return req("post", system_url + "/systemUserRole", params)
};

// 删除用户角色
export const deleteUserRole = (userRoleId) => {
  return req("delete", system_url + "/systemUserRole/" + userRoleId, null)
};

// 检查用户权限
export const checkUserPermission = () => {
  return req("get", system_url + "/checkUserPermission", null)
};

// 重置密码
export const resetPassword = (params) => {
  return req('post', security_url + "/user/resetPassword", params);
};

// 更新用户头像
export function updateUserAvatar(data) {
    return request({
        url: '/admin/systemUser/avatar/update',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 更新用户基本信息
export function updateUserProfile(data) {
    return request({
        url: '/admin/systemUser/profile/update',
        method: 'post',
        data
    })
}
// 更新用户联系方式
export function updateUserContact(data) { 
  return request({
      url: '/admin/systemUser/contact/update',
      method: 'post',
      data
  })
}



// WEBPACK FOOTER //
// ./src/api/userMG.js